import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Parallax } from 'react-parallax';
import BackgroundImageStyles from './BackgroundImgStyles-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { getCdnImage } from '../../../utils/ImageManager';
import i18nMessages from '../../../constants/messages/pt-BR';

class ParallaxImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      device: i18nMessages.desktop,
    };
  }
  componentDidMount() {
    window.addEventListener(i18nMessages.resize, this.handleWindowSizeChange);
    this.handleWindowSizeChange();
  }
  componentWillUnmount() {
    window.removeEventListener(
      i18nMessages.resize,
      this.handleWindowSizeChange
    );
  }
  handleWindowSizeChange = () => {
    if (window.innerWidth <= 767) {
      this.setState({ device: i18nMessages.mobile });
    } else if (window.innerWidth > 767 && window.innerWidth <= 1024) {
      this.setState({ device: i18nMessages.tablet });
    } else {
      this.setState({ device: i18nMessages.desktop });
    }
  };

  render() {
    const { backgroundImage } = this.props;
    const { device } = this.state;
    let stylesBack = backgroundImage.styles;
    const backgroundImageUrl =
      backgroundImage.backgroundImageCollection &&
      backgroundImage.backgroundImageCollection.items[0];
    let backgroundStyle = BackgroundImageStyles[i18nMessages.backgrounddefault];
    if (stylesBack && BackgroundImageStyles[stylesBack.trim()] !== undefined) {
      backgroundStyle = BackgroundImageStyles[stylesBack.trim()];
    }
    let desktopURL = '',
      smartphoneURL = '',
      tabletURL = '',
      altText = '';
    altText = backgroundImageUrl && backgroundImageUrl.altText;
    desktopURL =
      backgroundImageUrl &&
      backgroundImageUrl.desktopImage &&
      backgroundImageUrl.desktopImage.url;
    smartphoneURL =
      (backgroundImageUrl &&
        backgroundImageUrl.smartphoneImage &&
        backgroundImageUrl.smartphoneImage.url) ||
      desktopURL;
    tabletURL =
      (backgroundImageUrl &&
        backgroundImageUrl.tabletImage &&
        backgroundImageUrl.tabletImage.url) ||
      desktopURL;

    let widthClass;
    if (backgroundImage.componentWidth == null) {
      widthClass = '';
    } else {
      widthClass = getWidth(backgroundImage.componentWidth);
    }
    switch (device) {
      case i18nMessages.mobile:
        return (
          <div className={classNames(widthClass, backgroundStyle)}>
            {getParallax(smartphoneURL, altText)}
          </div>
        );
      case i18nMessages.tablet:
        return (
          <div className={classNames(widthClass, backgroundStyle)}>
            {getParallax(tabletURL, altText)}
          </div>
        );
      default:
        return (
          <div className={classNames(widthClass, backgroundStyle)}>
            {getParallax(desktopURL, altText)}
          </div>
        );
    }
  }
}

ParallaxImage.propTypes = {
  backgroundImage: PropTypes.oneOfType([PropTypes.object]),
};

ParallaxImage.defaultProps = {
  backgroundImage: null,
};

export default ParallaxImage;
export const getParallax = (url, altText) => {
  return (
    <Parallax
      bgImage={getCdnImage(url)}
      bgImageAlt={altText}
      bgClassName={BackgroundImageStyles.parallax}
      strength={200}
    >
      <div className={classNames(BackgroundImageStyles.imageHeight)} />
    </Parallax>
  );
};
